import { Popover2 } from '@blueprintjs/popover2'
import { useQuery } from '@tanstack/react-query'
import cx from 'classnames'
import useBackendClient from '~/api/BackendClient/useBackendClient'
import { CultureFilter } from '~/api/backend/pages/culturesPageAPI'
import { QUERY_KEYS } from '~/api/query-client-keys'
import MinimalButton from '~/components/buttons/MinimalButton'
import FilterIcon from '~/components/icons/FilterIcon'
import { CulturesFilterMenu } from './CulturesFilterMenu'
import { CulturesFilterPill } from './CulturesFilterPill'
import cs from './cultures_filter_bar.scss'

export function CulturesFilterBar(props: {
  className: string
  filters: CultureFilter[]
  setFilters: (filters: CultureFilter[]) => void
}) {
  const client = useBackendClient()
  const { data, isLoading } = useQuery({
    queryKey: [QUERY_KEYS.CULTURE_PAGE_CULTURE_FILTER_DEFINITIONS],
    queryFn: async () => await client.culturesPage.getCulturesFilterDefinitions(),
  })

  if (isLoading || !data) {
    return <div className={cx(props.className, cs.filterBar)} />
  }

  const renderTarget = ({ ...targetProps }) => (
    <div {...targetProps} className={cs.filterButton}>
      <MinimalButton
        label='Filter'
        IconComponent={FilterIcon}
        variant='tiny'
        onClick={() => {}} // Applies cursor: pointer style.
      />
    </div>
  )

  const removeFilterByField = (field: string) => {
    props.setFilters(props.filters.filter(f => f.field !== field))
  }

  const setFilter = (filterField: string, newFilter: CultureFilter | null) => {
    if (newFilter === null) {
      // If newFilter is null, remove the filter
      removeFilterByField(filterField)
      return
    }
    const existingFilterIndex = props.filters.findIndex(f => f.field === filterField)
    if (existingFilterIndex !== -1) {
      // Replace existing filter
      const newFilters = [...props.filters]
      newFilters[existingFilterIndex] = newFilter
      props.setFilters(newFilters)
    } else {
      // Add new filter
      props.setFilters([...props.filters, newFilter])
    }
  }

  return (
    <div className={cx(props.className, cs.filterBar)}>
      <Popover2
        content={
          <CulturesFilterMenu
            filterDefinitions={data}
            setFilter={setFilter}
            openFilterModal={() => {}}
            filters={props.filters}
          />
        }
        interactionKind='click'
        placement='bottom-start'
        renderTarget={renderTarget}
        minimal
      />
      {props.filters.map(filter => (
        <CulturesFilterPill
          filter={filter}
          key={filter.field}
          onDeleteClick={() => removeFilterByField(filter.field)}
        />
      ))}
    </div>
  )
}
